var HALF_PI = Math.PI/2;
var sign = require('./sign');

module.exports = function(x) {
  return (Math.abs(x) < HALF_PI) ? x : (x - (sign(x) * Math.PI));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/adjust_lat.js
// module id = 100
// module chunks = 0